<template>
  <div class="qrcode-card-wrapper" :class="{ 'fullscreen': isFullScreen }">
    <div class="svg-container">
      <!-- Import the SVG file -->
      <qrcode-gnt-svg class="qrcode-background-svg" />
      <!-- Overlay the QR Code in the center -->
      <div class="qrcode-overlay">
        <img
            v-if="hasValidQRCode"
            :src="item.enquete_qr_code.url"
            :alt="qrCodeAltText"
            class="qrcode-image"
            @error="onQRCodeError"
        />
        <div v-else class="qrcode-placeholder">
          <div class="qrcode-icon">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="#666">
              <path d="M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H9V11M15,11H17V13H15V11M19,11H21V13H19V11M5,19H7V21H5V19M3,5H9V11H3V5M5,7V9H7V7H5M13,13H15V15H13V13M15,15H17V17H15V15M17,17H19V19H17V17M15,3H21V9H15V3M17,5V7H19V7H17V5M21,11H23V13H21V11M19,3H21V5H19V3M11,1H13V3H11V1M19,1H21V3H19V1M7,15H9V17H7V15M3,13H5V15H3V13M21,15H23V17H21V15M5,11H7V13H5V11M21,13H23V15H21V13M21,17H23V19H21V17M11,15H13V17H11V15M17,13H19V15H17V13M21,19H23V21H21V19M13,17H15V19H13V17M11,17H13V19H11V17M13,19H15V21H13V19M11,13H13V15H11V13Z"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeGntSvg from '@/assets/SaiaJusta/Enquetes/qrcode_gnt.svg'

export default {
  name: 'CardTarjaEnqueteAngelicaQRCODE',
  components: {QrcodeGntSvg},
  props: {
    item: {
      type: Object,
      default: () => null
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    posicaoCard: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    hasValidQRCode() {
      return this.item?.enquete_qr_code?.url && this.item.enquete_qr_code.url.trim() !== '';
    },
    qrCodeAltText() {
      return `QR Code - ${this.item?.dsc_titulo_enquete || 'Participe da Enquete'}`;
    }
  },
  methods: {
    onQRCodeError(event) {
      console.error('Error loading QR Code image:', event);
      console.error('QR Code URL:', this.item?.enquete_qr_code?.url);
      this.$emit('qrcode-error', {
        url: this.item?.enquete_qr_code?.url,
        enqueteId: this.item?.id
      });
    }
  },
}
</script>

<style scoped lang="scss">
.qrcode-card-wrapper {
  position: fixed;
  bottom: 40px;
  left: 100px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 0;
  max-width: none;
  margin: 0;
  transition: all 0.3s ease;
  z-index: 100;

  &.fullscreen {
    bottom: 30px;
    left: 30px;
    transform: scale(1.1);
  }
}

.svg-container {
  position: relative;
  width: 252px;
  height: 425px;
}

.qrcode-background-svg {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
}

.qrcode-overlay {
  position: absolute;
  top: 141px;
  left: 32px;
  width: 189px;
  height: 189px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 4px;
}

.qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
}

.qrcode-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #666;
  text-align: center;
  padding: 16px;
  font-size: 12px;
}

.qrcode-icon {
  margin-bottom: 8px;
  opacity: 0.7;
}

/* Responsive adjustments for smaller screens */
@media (max-width: 768px) {
  .qrcode-card-wrapper {
    bottom: 10px;
    left: 10px;

    .svg-container {
      width: 200px;
      height: 337px;
      transform: scale(0.8);
    }

    &.fullscreen {
      bottom: 15px;
      left: 15px;
      transform: scale(0.9);
    }
  }
}

@media (max-width: 480px) {
  .qrcode-card-wrapper {
    bottom: 5px;
    left: 5px;

    .svg-container {
      width: 180px;
      height: 304px;
      transform: scale(0.7);
    }

    &.fullscreen {
      bottom: 10px;
      left: 10px;
      transform: scale(0.8);
    }
  }
}
</style>
